import React from "react";
import TableContainer from "../../elements/TableContainer";
import SubHeading from "../../elements/SubHeading";
import {OpenIdeasList} from "./OpenIdeasList";


const LongAndShortIdeas = ({openIdeas, showDetail}) => {
    const {longs, shorts} = openIdeas;
    const openIdeaCount = longs.length + shorts.length;
    if (openIdeaCount <= 0) {
        return <div className="t-no-open-ideas" style={{padding: "10px 20px"}}>No open ideas</div>;
    }

    return <div>
        <OpenIdeasList ideaType="Long" ideas={longs} showDetail={showDetail}/>
        <OpenIdeasList ideaType="Short" ideas={shorts} showDetail={showDetail}/>
    </div>;
};


const AuthorOpenIdeas = ({authorDetails, ideaActions}) => {
    return <TableContainer>
        <SubHeading>Open Ideas</SubHeading>
        <LongAndShortIdeas openIdeas={authorDetails.openIdeas}
                           showDetail={ideaActions.showDetail}/>
    </TableContainer>;
};

export default AuthorOpenIdeas;